// Excel / Google Sheets uyumlu CSV dışa aktarma (UTF-8 BOM ile Türkçe karakter desteği)
export function exportToCsv(filename, columns, rows) {
  const esc = (val) => {
    if (val === null || val === undefined) return "";
    const s = String(val);
    if (/[",\n;]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
    return s;
  };

  const header = columns.map((c) => esc(c.label)).join(";");
  const lines = rows.map((row) =>
    columns.map((c) => esc(c.format ? c.format(row[c.key], row) : row[c.key])).join(";")
  );

  const csv = "\uFEFF" + [header, ...lines].join("\r\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  const stamp = new Date().toISOString().slice(0, 10);
  a.href = url;
  a.download = `${filename}_${stamp}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
